var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52.3px",
    height: "63.4426968px",
    viewBox: "0 0 52.3 63.4426968",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-778.960000, -3769.467303)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "translate(-0.060000, -1.890000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M823.76,3823.62 L823.76,3818.22 C823.748999,3815.02846 821.161554,3812.44548 817.97,3812.44 L792.37,3812.44 C790.838243,3812.44254 789.37038,3813.05415 788.29,3814.14 L788.28,3814.14 C787.197821,3815.22202 786.589893,3816.68968 786.59,3818.22 L786.59,3827.24 L805.17,3827.24 L805.17,3834.8 L779.02,3834.8 L779.02,3818.22 C779.02669,3814.68262 780.440707,3811.2933 782.95,3808.8 L782.94,3808.79 C785.437262,3806.28174 788.830551,3804.87116 792.37,3804.87 L817.97,3804.87 C825.339346,3804.87882 831.311184,3810.85065 831.32,3818.22 L831.32,3823.62 L823.76,3823.62 L823.76,3823.62 Z M820.14,3786.29 C820.134037,3790.2527 818.55504,3794.05093 815.75,3796.85 L815.73,3796.86 C812.934858,3799.66358 809.138899,3801.23953 805.18,3801.24 L805.18,3801.26 C801.214755,3801.2569 797.4143,3799.67337 794.62,3796.86 L794.6,3796.86 C791.789833,3794.06232 790.210043,3790.26035 790.210043,3786.295 C790.210043,3782.32965 791.789833,3778.52768 794.6,3775.73 L794.6,3775.72 C798.882592,3771.45665 805.307957,3770.18507 810.891577,3772.49591 C816.475196,3774.80675 820.122756,3780.24711 820.14,3786.29 L820.14,3786.29 Z M812.570023,3786.29 C812.577447,3783.29624 810.77604,3780.59444 808.009589,3779.45015 C805.243138,3778.30587 802.059522,3778.94572 799.95,3781.07 L799.94,3781.06 C798.549342,3782.44378 797.768328,3784.32525 797.770202,3786.28708 C797.772083,3788.24891 798.556696,3790.12889 799.95,3791.51 L799.94,3791.52 C801.32671,3792.90808 803.207924,3793.68863 805.17,3793.69 L805.18,3793.71 C809.26099,3793.68096 812.557492,3790.37107 812.570023,3786.29 L812.570023,3786.29 Z",
    id: "Path_37"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon5.dca7756022761eebdb1ab9aceb4d8ce6.svg";
export { ForwardRef as ReactComponent };